import cx from 'classnames'
import { useHistory, useLocation } from 'react-router-dom'

import Styles from './Properties.module.scss'

import { usePropertiesPermissions } from 'hooks/usePropertiesPermissions'
import { useCurrentFolderStore } from 'hooks/stores/useCurrentFolderStore'

import { ChangeVisibilityButton } from './ChangeVisibilityButton'
import { PropertyForm } from 'common/PropertyForm/PropertyForm'
import { RemoveProperty } from './RemoveProperty'
import { Button } from 'components/Button/Button'
import { ReactComponent as SettingsIcon } from 'assets/icons/settings16.svg'
import { EditableProperty } from './Properties'

type Props = {
  editableProperty: EditableProperty
  onClose: () => void
}

export const EditWorkspaceProperty = ({ editableProperty, onClose }: Props) => {
  const { property } = editableProperty
  const { canEdit } = usePropertiesPermissions(property)
  const { currentFolder } = useCurrentFolderStore()

  const history = useHistory()
  const location = useLocation()

  const goToWorkspaceSettings = () => {
    const queryParams = new URLSearchParams(location.search)
    queryParams.set('settings', 'properties')
    history.push({ search: queryParams.toString() })
    onClose()
  }

  return (
    <>
      <PropertyForm
        variant="large"
        property={property}
        type={property.type}
        propertyTypes={[]}
        disabled={true}
        forceShowNameInput={true}
        forceShowTypeSelector={true}
      />

      <div className={Styles.mdText}>This is a workspace property, which can only be edited by a workspace Admin.</div>
      <div className={Styles.divider}></div>
      {canEdit ? (
        <div className={Styles.flexContainer}>
          <Button
            className={cx(Styles.flexContainer, Styles.flexGrow, Styles.horizontalPadding, Styles.columnGap0)}
            variant="tertiary"
            size="lg"
            onPress={goToWorkspaceSettings}
          >
            <SettingsIcon className={Styles.icon} />
            <div>Edit in Workspace Settings</div>
          </Button>
        </div>
      ) : (
        ''
      )}
      <ChangeVisibilityButton editableProperty={editableProperty} onClose={onClose} />
      {currentFolder?.has_edit_access ? <RemoveProperty property={property} onClose={onClose} /> : ''}
    </>
  )
}
